<template>
  <div id="app">
    <!-- loader start -->
    <div class="loader_skeleton" v-if="showSkeleton">
      <header>
        <div class="top-header d-none d-sm-block">
          <div class="container">
            <div class="row">
              <div class="col-lg-6">
                <div class="header-contact">
                  <ul>
                    <li>欢迎进入 Zerofast 在线商城</li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-6 text-end">
                <ul class="header-dropdown">
                  <li class="onhover-dropdown mobile-account">
                    <i class="fa fa-user" aria-hidden="true"></i> 我的账号
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="main-menu">
                <div class="menu-left">
                  <!--                  <div class="navbar">-->
                  <!--                    <a href="javascript:void(0)">-->
                  <!--                      <div class="bar-style">-->
                  <!--                        <i class="fa fa-bars sidebar-bar" aria-hidden="true"></i>-->
                  <!--                      </div>-->
                  <!--                    </a>-->
                  <!--                  </div>-->
                  <div class="brand-logo">
                    <a href="index.html">
                      <img src="https://www.zerofast.net/assets/images/logo-color.png" style="max-width: 200px;" class="img-fluid blur-up lazyload" alt="">
                    </a>
                  </div>
                </div>
                <div class="menu-right pull-right">
                  <div>
                    <nav>
                      <div class="toggle-nav">
                        <i class="fa fa-bars sidebar-bar"></i>
                      </div>
                      <ul class="sm pixelstrap sm-horizontal">
                        <li>
                          <div class="mobile-back text-end">Back <i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
                          </div>
                        </li>
                        <!--                        <li>-->
                        <!--                          <a href="index.html">Home</a>-->
                        <!--                        </li>-->
                      </ul>
                    </nav>
                  </div>
                  <div>
                    <div class="icon-nav d-none d-sm-block">
                      <ul>
                        <li class="onhover-div mobile-cart">
                          <div>
                            <img src="./assets/images/icon/cart.png" class="img-fluid blur-up lazyload" alt="">
                            <i class="ti-shopping-cart"></i>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="breadcrumb-section">
        <div class="container">
          <div class="row">
            <div class="col-sm-6">
              <div class="page-title">
<!--                <h2>product</h2>-->
              </div>
            </div>
            <div class="col-sm-6">
              <nav aria-label="breadcrumb" class="theme-breadcrumb">
<!--                <ol class="breadcrumb">-->
<!--                  <li class="breadcrumb-item">-->
<!--                    <a href="index.html">Home</a>-->
<!--                  </li>-->
<!--                  <li class="breadcrumb-item active" aria-current="page">product</li>-->
<!--                </ol>-->
              </nav>
            </div>
          </div>
        </div>
      </div>
      <section class="section-b-space ratio_asos">
        <div class="collection-wrapper product-page">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="main-product lg-img"></div>
                    </div>
                    <div class="col-lg-6">
                      <div class="product-right">
                        <h2></h2>
                        <h4></h4>
                        <h3></h3>
                        <ul>
                          <li></li>
                          <li></li>
                          <li></li>
                          <li></li>
                          <li></li>
                        </ul>
                        <div class="btn-group">
                          <div class="btn-ldr"></div>
                          <div class="btn-ldr"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <section class="tab-product m-0">
                  <div class="row">
                    <div class="col-sm-12 col-lg-12">
                      <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                      </ul>
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div >
    <!-- loader end -->
    <!-- header start -->
    <Header :cart="cart" :show-wechat="showWechat" :user-info="user" v-if="showHeader"></Header>
    <!-- header end -->
    <router-view/>
    <!-- footer start -->
    <Footer v-if="showFooter"></Footer>
    <!-- footer end -->
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import { getCart, getToken } from '@/libs/util'
import { getUserInfo } from '@/api/user'
import { User } from '@/api/model'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      cart: [],
      showWechat: false,
      user: User(),
      showHeader: true,
      showFooter: true,
      showSkeleton: true,
      isLoadUser: true
    }
  },
  methods: {
    getCart () {
      this.cart = getCart()
    },
    getUserInfo () {
      const token = getToken()
      if (token === false) {
        return false
      }
      if (this.isLoadUser) {
        getUserInfo().then(res => {
          if (res.code !== 200) {
            this.$message.info(res.msg)
            return false
          }
          this.user = res.result
        })
      }
    }
  }
}
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue